import type { ExplorationVolume, ViewMode } from '../../types/exploration';
import { currentInnerPalette } from './sidebarPalettes';

export function volumeStatusLabel(v: ExplorationVolume, view: ViewMode): string {
  const palette = currentInnerPalette(view);
  return palette.field === 'supportStatus' ? v.supportLabel : v.activationLabel;
}

/** Opportunity-style support label even when the UI view is activation (e.g. Unattached sub-buckets). */
export function supportStyleStatusLabel(v: ExplorationVolume, view: ViewMode): string {
  return volumeStatusLabel(v, view === 'activation' ? 'exploration' : view);
}
